<template>
    <div id="chooseMapel">
        <!-- selection mapel with image icon -->
        <v-select
            class="pa-0"
            v-model="selectedMapel"
            :items="mapels"
            outlined
            dense
            item-text="nama"
            item-value="code"
            placeholder="Ketik mata pelajaran"
            @click="showMapels()"
            @change="selectMapel"
        >
            <template v-slot:selection="{ item }">
                <v-list-item class="pa-0 ma-0">
                    <v-list-item-avatar>
                        <img :src="item.picture" />
                    </v-list-item-avatar>
                    <v-list-item-title>{{ item.nama }}</v-list-item-title>
                </v-list-item>
            </template>
            <template v-slot:item="{ item }">
                <v-list-item-avatar>
                    <img :src="item.picture" />
                </v-list-item-avatar>
                <v-list-item-title>{{ item.nama }}</v-list-item-title>
            </template>
        </v-select>
    </div>
</template>

<style>
li.list-group-item:hover {
    cursor: pointer;
    background-color: #00ff99;
}

.mapel-picture {
    float: left;
    width: 45px;
    height: 34px;
    -webkit-border-radius: 50px;
    -moz-border-radius: 50px;
    border-radius: 50px;
    overflow: hidden;
    margin: -2px 10px -2px 0;
}

#mapelModal {
    width: 50%;
}
</style>

<script>
import ItembankService from "@/modules/itembank/services/itembank.js";
import Spinner from "@/modules/global/components/plugins/Spinner";

export default {
    name: "app-choosemapel",

    components: {
        "app-spinner": Spinner,
    },

    data: function () {
        return {
            selectedMapel: null,
            isLoading: false,
            showMapelModal: false,
            mapels: [],
        };
    },

    methods: {
        // get all data mapel
        showMapels: function () {
            var context = this;
            context.isLoading = true;
            ItembankService.getListMataPelajaran(function (result) {
                if (result.success) {
                    context.mapels = result.data;
                    context.showMapelModal = true;
                }

                context.isLoading = false;
            });
        },

        // get detail mapel by code mapel (index = code mapel)
        selectMapel: function (index) {
            this.selectedMapel = this.mapels.find(function (element) {
                return element.code == index;
            });
            this.showMapelModal = false;
            this.$emit("selected", this.selectedMapel);
        },
    },

    mounted: function () {
        // get detail mapel if subtest was update
        if (this.$store.getters.selectedSubtest) {
            this.showMapels();
            var mapel = {
                nama: this.$store.getters.selectedSubtest.subject_name,
                code: this.$store.getters.selectedSubtest.subject_code,
            };

            this.selectedMapel = mapel;
        }
    },
};
</script>



// WEBPACK FOOTER //
// ChooseMapel.vue?0c437155